import { get, post, put } from "./api_helper";
import config from "../config";
import * as url from "./url_helper";

// Register Method
const postRegister = (data: any) =>
  post(url.POST_REGISTER, data, {}, true, false);

// Login Method
const postLogin = (data: any) => post(url.POST_FAKE_LOGIN, data);

// Affiliates
export const getAffiliateProfile = (id: number) =>
  get(`${url.AFFILIATES}/${id}`);

//Color Settings
export const updateColorSettings = (data: object) =>
  put(url.UPDATE_COLORS, data);

export const restoreColorSettings = () => put(url.RESTORE_COLORS, undefined);

export const getColorSettings = (settingType: string) =>
  get(
    `${url.GET_COLOR_SETTINGS}/${settingType}`,
    settingType === "colors"
      ? undefined
      : {
          responseType: "blob",
        }
  );

export const getAuthLogo = (): Promise<File> =>
  get(url.GET_AUTH_LOGO, {
    responseType: "blob",
  });

export const getAuthStartPagePicture = (): Promise<File> =>
  get(url.GET_AUTH__START_PAGE_PICTURE, {
    responseType: "blob",
  });

// Permissions
export const getPermissionsList = (id: number) =>
  get(`${url.GET_PERMISSIONS}/${id}`);

// Forgot Password
export const sendResetPassword = (email: string) =>
  post(
    `${url.RECOVERY_PASSWORD}`,
    { email },
    { baseURL: config.traffme.passwordUrlApi }
  );

export const sendNewPassword = ({
  token,
  newPassword,
}: {
  token: string;
  newPassword: string;
}) =>
  post(
    `${url.RECOVERY_PASSWORD}/${token}`,
    { newPassword },
    { baseURL: config.traffme.passwordUrlApi }
  );

export { postRegister, postLogin };
